<template>
  <div class="w-full flex flex-col items-center">
    <!-- Main Container -->
    <div class="flex flex-col md:flex-row gap-6 w-full">

      <!-- Left: Transaction Data -->
      <div class="w-1/2">
        <h2 class="font-semibold text-gray-700 mb-4">TRANSACTION DATA</h2>

        <div class="border border-gray-200 bg-white rounded-lg shadow p-4">
          <div class="divide-y divide-gray-300">
            <div class="flex justify-between p-2">
              <span class="text-gray-500">Account to Debit</span>
              <span class="text-gray-800 text-right">
                {{ transactionData?.account?.account_name }} - {{
                  transactionData?.account?.account_number
                }} ({{ transactionData?.account?.currency }})
              </span>
            </div>
            <div class="flex justify-between p-2">
              <span class="text-gray-500">IBAN</span>
              <span class="text-gray-800 text-right">{{ transactionData?.beneficiary?.iban }}</span>
            </div>
            <div class="flex justify-between p-2">
              <span class="text-gray-500">BIC / SWIFT Code</span>
              <span class="text-gray-800 text-right">{{ transactionData?.beneficiary?.swift }}</span>
            </div>
            <div class="flex justify-between p-2">
              <span class="text-gray-500">Beneficiary Name</span>
              <span class="text-gray-800 text-right">{{ transactionData?.beneficiary?.name }}</span>
            </div>
            <div class="flex justify-between p-2">
              <span class="text-gray-500">Beneficiary Address</span>
              <span class="text-gray-800 text-right">{{ transactionData?.beneficiary?.beneficiary_address }}</span>
            </div>
            <div class="flex justify-between p-2">
              <span class="text-gray-500">Beneficiary Bank Address</span>
              <span class="text-gray-800 text-right">{{ transactionData?.beneficiary?.beneficiary_bank_address }}</span>
            </div>
            <div class="flex justify-between p-2">
              <span class="text-gray-500">City</span>
              <span class="text-gray-800 text-right">{{ transactionData?.beneficiary?.city }}</span>
            </div>
            <div class="flex justify-between p-2">
              <span class="text-gray-500">Country</span>
              <span class="text-gray-800 text-right">{{ transactionData?.beneficiary?.country }}</span>
            </div>
            <div class="flex justify-between p-2">
              <span class="text-gray-500">Post Code</span>
              <span class="text-gray-800 text-right">{{ transactionData?.beneficiary?.post_code }}</span>
            </div>
            <div class="flex justify-between p-2">
              <span class="text-gray-500">Value</span>
              <span class="text-gray-800 text-right">{{ transactionData?.account?.currency }} {{ transactionData?.value }}</span>
            </div>
            <div class="flex justify-between p-2">
              <span class="text-gray-500">Description</span>
              <span class="text-gray-800 text-right">{{ transactionData?.description }}</span>
            </div>
<!--            <div class="flex justify-between p-2">-->
<!--              <span class="text-gray-500">Reason for Payment</span>-->
<!--              <span class="text-gray-800 text-right">{{ transactionData?.paymentReason }}</span>-->
<!--            </div>-->
            <div class="flex justify-between p-2">
              <span class="text-gray-500">Additional Information</span>
              <span class="text-gray-800 text-right">{{ transactionData?.beneficiary?.additional_info }}</span>
            </div>
            <div class="flex justify-between p-2">
              <span class="text-gray-500">Intermediary Bank</span>
              <span class="text-gray-800 text-right">
                {{ transactionData?.beneficiary?.intermediary_bank_name }} {{ transactionData?.beneficiary?.intermediary_bank_bic }}
              </span>
            </div>
            <!-- Attachments -->
<!--            <div v-if="transactionData?.attachments?.length" class="p-2">-->
<!--              <span class="text-gray-500 block">Attachments</span>-->
<!--              <ul class="text-gray-800 text-sm mt-1 list-disc list-inside">-->
<!--                <li v-for="(file, idx) in transactionData?.attachments" :key="idx">-->
<!--                  {{ file.file?.name || file.name }} - {{ file.description }}-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
          </div>
        </div>
      </div>

      <!-- Right: Operation Confirmation -->
      <div
          class="w-1/2 flex flex-col h-fit gap-y-2 bg-white border border-orange-300 text-sm text-gray-700 p-4 rounded-lg mb-8 shadow mt-10">
        <div class="flex items-center gap-2">
          <component :is="Info" class="w-5 h-5 text-primary"/>
          <p class="text-gray-800 font-semibold">YOUR REQUEST WAS REGISTERED (ID: {{ transactionId || 'Pending' }})</p>
        </div>

        <div class="flex justify-center">
          <span>Processing...</span>
        </div>
      </div>
    </div>

    <!-- Go Back / New Transfer Buttons -->
    <div class="flex flex-col md:flex-row w-full justify-center mt-6 gap-4">
      <button @click="downloadPDF"
              class="w-full md:w-1/4 px-8 py-3 text-primary rounded-md bg-white font-semibold transition shadow"
      >
        Download PDF
      </button>
      <button
          @click="newTransfer"
          class="w-full md:w-1/4 px-8 py-3 rounded-md text-white bg-primary font-semibold transition shadow"
      >
        NEW TRANSFER
      </button>
    </div>
  </div>
</template>

<script setup>
import {defineProps, defineEmits} from 'vue';
import {Info} from 'lucide-vue-next';
import jsPDF from 'jspdf';
// import {formatNumber} from "@/utils/number";

const props = defineProps({
  transactionData: {type: Object, default: () => ({})},
  transactionId: {type: String, default: ''},
  selectedAccount: {type: Object,required: true},
});

const emit = defineEmits(['update:modelValue']);


const newTransfer = () => {
  emit('update:modelValue', false);
};


const downloadPDF = () => {
  if (!props.transactionData) return;

  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();
  const leftMargin = 14;
  const rightMargin = 14;
  const contentWidth = pageWidth - leftMargin - rightMargin;

  const primaryColor = [241, 96, 8];
  const boxBgColor = [255, 250, 245];
  // const secondaryColor = [245, 245, 245];

  // هدر
  doc.setFillColor(...primaryColor);
  doc.rect(0, 0, pageWidth, 20, "F");
  doc.setFontSize(18);
  doc.setTextColor(255);
  doc.setFont("helvetica", "bold");
  doc.text("Transaction Confirmation", leftMargin, 12);

  let currentY = 30;

  // Sender
  // const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
  doc.setFillColor(...boxBgColor);
  doc.setDrawColor(...primaryColor);
  doc.roundedRect(leftMargin, currentY, contentWidth / 2 - 4, 50, 2, 2, "FD");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.setTextColor(50);
  doc.text("Sender:", leftMargin + 3, currentY + 8);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  const safeValue = (val) => val ?? "-";

  doc.text(`Name: ${safeValue(currentUser.name)}`, leftMargin + 3, currentY + 16);
  doc.text(`Account Number: ${safeValue(props.selectedAccount.account_number)}`, leftMargin + 3, currentY + 23);
  doc.text(`IBAN: ${safeValue(props.selectedAccount.iban)}`, leftMargin + 3, currentY + 30);
  doc.text(`Swift Code: ${safeValue(props.selectedAccount.swift)}`, leftMargin + 3, currentY + 37);
  doc.text(`Currency: ${safeValue(props.selectedAccount.currency)}`, leftMargin + 3, currentY + 44);

  // Receiver
  doc.setFillColor(255, 255, 255);
  doc.setDrawColor(...primaryColor);
  doc.roundedRect(pageWidth / 2, currentY, contentWidth / 2 - 4, 50, 2, 2, "FD");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.setTextColor(50);
  doc.text("Receiver:", pageWidth / 2 + 3, currentY + 8);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);

  const beneficiary = props.transactionData.beneficiary || {};
  doc.text(`Name:${beneficiary.name || "-"}`, pageWidth / 2 + 3, currentY + 16);
  doc.text(`IBAN: ${beneficiary.iban || "-"}`, pageWidth / 2 + 3, currentY + 23);
  if (beneficiary.account_number) doc.text(`Account Number: ${beneficiary.account_number}`, pageWidth / 2 + 3, currentY + 30);
  if (beneficiary.type) {
    let typeLabel = '';
    if (beneficiary.type === 'european') {
      typeLabel = 'SEPA Transfer';
    } else if (beneficiary.type === 'international') {
      typeLabel = 'Swift Transfer';
    } else {
      typeLabel = beneficiary.type; // fallback برای بقیه مقادیر
    }

    doc.text(`Type: ${typeLabel}`, pageWidth / 2 + 3, currentY + 37);
  }
  if (beneficiary.swift) doc.text(`Swift: ${beneficiary.swift}`, pageWidth / 2 + 3, currentY + 44);
  if (beneficiary.additional_info) doc.text(`Note: ${beneficiary.additional_info}`, pageWidth / 2 + 3, currentY + 44);
  currentY += 60;

  // Transaction Details Box
  // doc.setFillColor(...secondaryColor);
  // doc.roundedRect(leftMargin, currentY, contentWidth, 170, 2, 2, "FD");

  let boxStartY = currentY + 10;
  let y = boxStartY;
  const addRow = (label, value) => {
    const fontSize = 13; // اندازه فونت بزرگ‌تر
    const linePadding = 4; // فاصله بالای خط
    const infoLineHeight = 7; // ارتفاع هر خط متن
    const rightPadding = 10; // فاصله از سمت راست

    doc.setFontSize(fontSize);

    let displayLabel = label.replace(/\bId\b/gi, 'ID');
    // متن چپ (label)
    doc.setFont("helvetica", "bold");
    doc.setTextColor(50);
    doc.text(displayLabel, leftMargin + 10, y + fontSize / 2);

    // متن راست (value)
    doc.setFont("helvetica", "normal");
    doc.setTextColor(80);
    const splitVal = doc.splitTextToSize(String(value || "-"), contentWidth - 70);
    const valueOffset = (splitVal.length - 1) * infoLineHeight / 2;
    doc.text(
        splitVal,
        leftMargin + contentWidth - rightPadding,
        y + fontSize / 2 - valueOffset,
        { align: "right" }
    );

    // خط زیر ردیف
    const lineY = y + splitVal.length * infoLineHeight + linePadding;
    if (!isNaN(lineY)) {
      doc.setDrawColor(200); // خاکستری پررنگ‌تر
      doc.setLineWidth(0.1);
      doc.line(leftMargin, lineY, leftMargin + contentWidth, lineY);
    }

    // فاصله بعدی
    y += splitVal.length * infoLineHeight + linePadding;
  };

  // const boxHeight = y - boxStartY + 10; // ارتفاع واقعی باکس بر اساس ردیف‌ها

// رسم باکس با ارتفاع داینامیک
//   doc.setFillColor(...secondaryColor);
//   doc.roundedRect(leftMargin, boxStartY - 10, contentWidth, boxHeight, 2, 2, "FD");


  Object.entries(props.transactionData).forEach(([key, val]) => {
    if (val !== null && val !== "" && val !== undefined
        && key !== "approval_status"
        && key !== "beneficiary"
        && key !== "balance"
        && key !== "value_date"
        && key !== "created_at"
        && key !== "updated_at"
        && key !== "file_path"
        && key !== "account"
    ) {
      addRow(formatLabel(key), formatValue(val, key, props.transactionData));
    }
  });

  // Footer
  const pageHeight = doc.internal.pageSize.height;
  doc.setFontSize(9);
  doc.setTextColor(100);
  doc.text(`Generated on: ${new Date().toLocaleString()}`, leftMargin, pageHeight - 10);
  doc.text("© 2025 Bison Account. All rights reserved.", 120, pageHeight - 10);

  doc.save(`transaction_${props.transactionData.id || "pending"}.pdf`);
};


const formatLabel = (label) => label.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());

const formatValue = (val, key = null, transaction = {}) => {
  if (val === null || val === undefined || val === "") return "-";
  if (["value", "balance", "fee"].includes(key)) {
    const num = Number(val);
    if (!isNaN(num)) return num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + " " + (transaction.currency || "");
  }
  if (typeof val === "string") {
    const isoDatePattern = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2})?/;
    if (isoDatePattern.test(val)) {
      const date = new Date(val);
      if (!isNaN(date.getTime())) return date.toLocaleString();
    }
  }
  if (val instanceof Date && !isNaN(val.getTime())) return val.toLocaleString();
  return val;
};


</script>

<style scoped>
.h-fit {
  height: fit-content;
}
</style>
